import { createTheme, Theme } from '@mui/material';

export type ThemeOptions = 'default' | 'light';
export const chooseTheme = (chosenTheme: ThemeOptions): Theme => {
	switch (chosenTheme) {
		case 'light':
			return lightTheme;
		default:
			return darkTheme;
	}
};

const lightTheme = createTheme({
	palette: {
		mode: 'light',
		background: {
			paper: '#f8f8f8', // Slightly darker to differentiate from background default
		},
	},
});

const darkTheme = createTheme({
	palette: {
		mode: 'dark',
		background: {
			default: '#030303', // Dark background for the app
			paper: '#1e1e1e', // Slightly lighter background for paper components
		},
		text: {
			primary: '#ffffff', // White color for primary text
			secondary: '#b0b0b0', // Light grey color for secondary text
		},
		primary: {
			main: '#90caf9', // Light blue for primary elements
		},
		secondary: {
			main: '#f48fb1', // Pink for secondary elements
		},
		error: {
			main: '#E91B0C', // slightly darker color for error to meet contrast ratio
		},
	},
	typography: {
		allVariants: {
			color: '#ffffff', // Set all typography variants to white color
		},
	},
});
